<template>
    <div class="min-h-screen bg-white text-gray-800" v-if="!isMobile">
        <header class="bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md">
            <div class="topBox w-full fixed top-0 z-50">
                <img
                    style="width: 60px; height: 60px; margin-left: 60px"
                    src="http://cdnwm.yuluojishu.com/uploads/20251208/e62ce63e687cb4a314f465c84fbd48b5.png"
                    alt=""
                />
                <!-- 桌面导航 -->
                <nav class="labelBox space-x-4 hidden md:block">
                    <a href="#home" class="hover:underline">首页</a>
                    <a href="#kissuCont" class="hover:underline">KISS定义</a>
                    <a href="#kissanme" class="hover:underline">KISS一下</a>
                    <a href="#joinus" class="hover:underline">加入我们</a>
                </nav>
            </div>
        </header>
        <section id="home" class="contentBox text-center py-20 px-4 bg-gray-100">
            <div class="containerBox">
                <div class="text">
                    <img
                        style="height: 39px"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/bc061a25127b06ec551d35015d200a3a.png"
                        alt=""
                    />
                </div>
                <div class="text">
                    <img
                        style="height: 39px"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/44fba5ef02d97012739b00dcd17a5cd8.png"
                        alt=""
                    />
                </div>
                <div class="text">
                    <img
                        style="height: 39px"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/b30e82775aaf44175493a3ba831d6819.png"
                        alt=""
                    />
                </div>
            </div>
            <div class="kissBox">
                <img
                    style="height: 137px; max-width: 565px"
                    class="w-[30%] h-auto"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/ca1dfcdb445be416431f8da98602077b.png"
                    alt=""
                />
            </div>
            <div class="uploadBox">
                <div class="uploadBtn">
                    <img
                        style="height: 80px; width: 321px"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/705415d95189713ecb23c6eb538f4fbd.png"
                        alt=""
                    />
                </div>
                <!-- <div class="uploadBtn"><img style="height: 80px;width: 321px;" src="http://cdnwm.yuluojishu.com/uploads/20250723/3b6de512320ffa805fd87e2bc528bda4.png" alt="">
                </div> -->
            </div>
            <div class="bottomLogo">
                <div class="bomLogo"></div>
                <div class="bomLogo">
                    <img
                        style="height: 32px; width: 390px"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/1d490923dde4377efe0df8f65ca706c9.png"
                        alt=""
                    />
                </div>
            </div>
        </section>
        <section id="kissuCont" class="TwoContent text-center py-20 px-4 bg-gray-100">
            <div class="uploadBtn">
                <img
                    style="width: 100%; height: 100%"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/a409b6262358c2df7f0928b16113b0dc.png"
                    alt=""
                />
            </div>
        </section>
        <section id="kissanme" class="threedContent text-center py-20 px-4 bg-gray-100">
            <div class="uploadBtnThree">立即下载</div>
            <div class="animationBox">
                <div class="cardOne" data-speed="1.2">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/09723c29b0cea6f84c38b1a04afad415.png"
                        alt=""
                    />
                </div>
                <div class="cardTwo" data-speed="1.0">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/e06277fdf7288d3d2da43800b44f3e98.png"
                        alt=""
                    />
                </div>
                <div class="cardThree" data-speed="0.8">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/acb9eef6bfb007ff02973b6250015e00.png"
                        alt=""
                    />
                </div>
                <div class="cardFour" data-speed="0.6">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/e06277fdf7288d3d2da43800b44f3e98.png"
                        alt=""
                    />
                </div>
                <div class="cardfive" data-speed="0.6">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/6b99e5e7f7f5fb62dab2eed228415641.png"
                        alt=""
                    />
                </div>
                <div class="cardsix" data-speed="0.6">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/6485a2ba364dad319cdefb77f2bc47c1.png"
                        alt=""
                    />
                </div>
                <div class="cardseven" data-speed="0.6">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/e06277fdf7288d3d2da43800b44f3e98.png"
                        alt=""
                    />
                </div>
                <div class="cardeight" data-speed="0.6">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/1729b00d2fc6ff44f1759251ce6c4715.png"
                        alt=""
                    />
                </div>
                <div class="cardnight" data-speed="0.6">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/bd14ba7f4331424b38433d6868b211e7.png"
                        alt=""
                    />
                </div>
            </div>
        </section>
        <section class="fourContent text-center py-20 px-4 bg-gray-100">
            <div class="aiBox">
                <div class="imgOne">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/eae7bd26c890f854a600f8aa7d5726e9.png"
                        alt=""
                    />
                </div>
                <div class="imgTwo">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/2b18228e2e43b4e5610d2bcdb859cca0.png"
                        alt=""
                    />
                </div>
            </div>
            <div class="aiTwobox">
                <div class="leftTextbox">
                    <p style="width: 100%">你期待的</p>
                    <p style="width: 100%">情侣陪伴App</p>
                    <p style="width: 100%">是什么样子的呢？</p>
                </div>
                <div class="swiper-container rightTextbox">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in cards" :key="index">
                            <div class="flip-container">
                                <div class="flipper">
                                    <div class="front">
                                        <div class="frontcontent">
                                            <div class="frontImg">
                                                <img
                                                    style="width: 100%; height: 100%; border-radius: 50%"
                                                    :src="item.avater"
                                                    alt=""
                                                />
                                            </div>
                                            <p>{{ item.title }}</p>
                                            <div class="divider"></div>
                                            <div class="frontContent">{{ item.desc }}</div>
                                        </div>
                                    </div>
                                    <div class="back">
                                        <div class="backContent">
                                            <div class="backToptext">
                                                <div>{{ item.date }}</div>
                                                <div class="likeCount">
                                                    <img
                                                        src="http://cdnwm.yuluojishu.com/uploads/20250723/078412a81ae55a49c5047d443000e343.png"
                                                    />
                                                    <span>{{ item.likes }}</span>
                                                </div>
                                            </div>
                                            <div class="subtitle">{{ item.title }}</div>
                                            <div class="divider small"></div>
                                            <div class="exporaText">{{ item.longDesc }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fotterBox">
                    <div class="fotterLeft">
                        <p>每一位用户的想法，我们都会认真聆听~</p>
                        <p>请下载App体验后留下真实的想法叭</p>
                    </div>
                    <div class="fotterRight">
                        <div style="display: flex">
                            <div style="display: flex; align-items: center">
                                联系我们:
                                <img
                                    style="width: 21px; height: 20px; margin: 0 10px"
                                    src="http://cdnwm.yuluojishu.com/uploads/20250723/6619b39739fe1fab2c7881babeaa79e9.png"
                                    alt=""
                                />
                                19033919070
                            </div>
                            <div style="display: flex; align-items: center; margin-left: 20px">
                                <img
                                    src="http://cdnwm.yuluojishu.com/uploads/20250723/8cc277d4e3bd8bed8a6b5021189353e9.png"
                                    style="width: 21px; height: 21px; margin: 0 10px"
                                    alt=""
                                />kefu@yuluojishu.com
                            </div>
                        </div>
                        <div>
                            <a href="https://beian.miit.gov.cn/">浙ICP备2021021692号-17</a> |
                            <a href="https://beian.mps.gov.cn/#/query/webSearch">浙公网安备33010502012332号</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="joinus" class="joinusContent text-center py-20 px-4 bg-gray-100">
            <div class="joinLeft">
                <img
                    style="width: 100%; height: 100%"
                    src="http://cdnwm.yuluojishu.com/uploads/20250723/961237f82666af16d28d98c4bc71492d.png"
                    alt=""
                />
            </div>
            <div class="joinRight">
                <div class="joinTitle">
                    <img
                        style="width: 100%; height: 100%"
                        src="http://cdnwm.yuluojishu.com/uploads/20250723/95b118c20e65993b19d7ff4494350ad7.png"
                        alt=""
                    />
                </div>
                <div class="joinupload">
                    <div style="display: flex; width: 60%; justify-content: space-between">
                        <div v-for="(item, index) in jobList" :key="index">
                            <el-button
                                :style="{
                                    background: jobSelse == item.value ? '#FFA9BC' : '',
                                    color: jobSelse == item.value ? '#fff' : '',
                                }"
                                @click="jobSelse = item.value"
                                >{{ item.title }}</el-button
                            >
                        </div>
                    </div>
                    <div class="joinuploadBox">
                        <div class="joinContent">
                            <div style="display: flex; align-items: center">
                                你的简历<el-upload
                                    class="upload-demo"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    multiple
                                    style="margin-left: 20px"
                                    :show-file-list="false"
                                >
                                    <el-button size="small" style="background: #ffa9bc; color: #fff"
                                        >点击上传</el-button
                                    >
                                </el-upload>
                            </div>
                            <div style="display: flex; align-items: center; margin-top: 20px">
                                你的邮箱
                                <el-input
                                    v-model="input"
                                    placeholder="有效邮箱"
                                    style="width: 80%; margin-left: 20px"
                                ></el-input>
                            </div>
                            <div style="width: 100%; display: flex; justify-content: center">
                                <el-button
                                    style="background: #ffa9bc; color: #fff; margin-top: 20px; width: 200px"
                                    @click="sumbit()"
                                    >提交</el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <MobileHome v-else />
</template>

<script lang="ts">
import MobileHome from "./MobileHome.vue";
import Swiper from "swiper";
export default {
    data() {
        return {
            isMobileNavOpen: false,
            jobList: [
                { title: "手绘原画师", value: 1 },
                { title: "动效师", value: 2 },
                { title: "PHP", value: 3 },
                { title: "新媒体运营", value: 4 },
            ],
            cards: [
                {
                    title: "hh.",
                    desc: "从谈到这个App的时候我们就已经开始无话不说，慢慢的越来越近，我们一起经营着这段感情，现在我们隔了很远很远，仍然时刻kiss U，这大概就是爱情的魔力吧",
                    longDesc:
                        "从谈到这个App的时候我们就已经开始无话不说，慢慢的越来越近，我们一起经营着这段感情，现在我们隔了很远很远，仍然时刻kiss U，这大概就是爱情的魔力吧",
                    date: "2025.7.12",
                    likes: 99,
                    avater: "http://cdnwm.yuluojishu.com/uploads/20250721/bbb57c8e63485e6d28643d90c1bfb057.png",
                },
                {
                    title: "暖暖",
                    desc: "我们是在异地恋中偶然刷到这个 App 的，一开始只是想试试，结果完全上头！每天打卡签到、互送小红花、许愿清单、纪念日提醒……每一个功能都甜到让人尖叫。我们甚至会在“情侣日记”里互写情书，把以前不敢说的情话写下来，比微信聊天有温度太多。现在打开这个 App 成了我一天中最期待的事，就像打开我们的小世界，只有我和他能进来。",
                    longDesc:
                        "我们是在异地恋中偶然刷到这个 App 的，一开始只是想试试，结果完全上头！每天打卡签到、互送小红花、许愿清单、纪念日提醒……每一个功能都甜到让人尖叫。我们甚至会在“情侣日记”里互写情书，把以前不敢说的情话写下来，比微信聊天有温度太多。现在打开这个 App 成了我一天中最期待的事，就像打开我们的小世界，只有我和他能进来。",
                    date: "2025.7.12",
                    likes: 190,
                    avater: "http://cdnwm.yuluojishu.com/uploads/20250721/e6ada3fd463f3ab4cc666e38f9315193.jpg",
                },
                {
                    title: "wsy",
                    desc: "这 App 太懂女孩子的心思了，什么恋爱提醒、专属背景、情侣头像、亲密等级通通安排上了！有时候我生气不想讲话，他就用 App 里的“哄哄我”功能写道歉小纸条，一秒化解冷战哈哈哈。我们还设定了“情侣守则”，像是“每周至少发一次情话”、“生气不能超过 2 小时”，现在都变成了感情里的小默契。真的觉得，有了它，连吵架都更温柔了",
                    longDesc:
                        "这 App 太懂女孩子的心思了，什么恋爱提醒、专属背景、情侣头像、亲密等级通通安排上了！有时候我生气不想讲话，他就用 App 里的“哄哄我”功能写道歉小纸条，一秒化解冷战哈哈哈。我们还设定了“情侣守则”，像是“每周至少发一次情话”、“生气不能超过 2 小时”，现在都变成了感情里的小默契。真的觉得，有了它，连吵架都更温柔了",
                    date: "2025.7.12",
                    likes: 77,
                    avater: "http://cdnwm.yuluojishu.com/uploads/20250721/cda99f4c6825e406a88d3971e231c3d4.jpg",
                },
                {
                    title: "wuli胡哈哈",
                    desc: "以前我们只是微信聊天、偶尔视频，感觉平淡得像朋友。但用了这个情侣 App 之后，每天的互动变得特别有仪式感。比如他会提前在 App 里设置我生日的惊喜倒计时，或者写个“偷偷想你”的语音便签放在留言板里。最戳心的是，我们一起写了未来旅行的愿望清单，现在每完成一个都会打勾，感觉在一起真的越来越有目标。很感谢这个 App，把我们的日常生活变成了一场浪漫电影",
                    longDesc:
                        "以前我们只是微信聊天、偶尔视频，感觉平淡得像朋友。但用了这个情侣 App 之后，每天的互动变得特别有仪式感。比如他会提前在 App 里设置我生日的惊喜倒计时，或者写个“偷偷想你”的语音便签放在留言板里。最戳心的是，我们一起写了未来旅行的愿望清单，现在每完成一个都会打勾，感觉在一起真的越来越有目标。很感谢这个 App，把我们的日常生活变成了一场浪漫电影",
                    date: "2025.7.12",
                    likes: 127,
                    avater: "http://cdnwm.yuluojishu.com/uploads/20250721/f5d58ee35afe2e648d9a792a77dbc51c.jpg",
                },
                {
                    title: "王小帅",
                    desc: "最喜欢这个 App 的地方，就是它帮我们记录了很多平常不会保存的“碎片时刻”：凌晨 1 点的语音告白、第一次做饭失败的合照、一起许下的 100 个小愿望……每次回看都像是翻开一本属于我们的相册，让人很有安全感。而且它比朋友圈更私密，只属于我们两个。每段感情都值得被认真对待，这个 App 就是那个帮我们“认真”的角色。",
                    longDesc:
                        "最喜欢这个 App 的地方，就是它帮我们记录了很多平常不会保存的“碎片时刻”：凌晨 1 点的语音告白、第一次做饭失败的合照、一起许下的 100 个小愿望……每次回看都像是翻开一本属于我们的相册，让人很有安全感。而且它比朋友圈更私密，只属于我们两个。每段感情都值得被认真对待，这个 App 就是那个帮我们“认真”的角色。",
                    date: "2025.7.12",
                    likes: 999,
                    avater: "http://cdnwm.yuluojishu.com/uploads/20250721/1df17a8a4d7d3c13eb30592113cc50bf.jpg",
                },
                {
                    title: "郑进湾",
                    desc: "用这个 App 久了，会有一种“我们不是在谈恋爱，是在养一段感情”的感觉。每天完成打卡任务、签到获取小道具、累计亲密值解锁纪念背景……好像我们是一对“恋爱搭档”，一起经营一个叫“爱情”的游戏。而且越用越上头，连我男朋友这个原本“钢铁直男”都被我带入坑了，现在他比我还主动发情侣照片。哈哈，这就是甜宠 App 的魔力吧。",
                    longDesc:
                        "用这个 App 久了，会有一种“我们不是在谈恋爱，是在养一段感情”的感觉。每天完成打卡任务、签到获取小道具、累计亲密值解锁纪念背景……好像我们是一对“恋爱搭档”，一起经营一个叫“爱情”的游戏。而且越用越上头，连我男朋友这个原本“钢铁直男”都被我带入坑了，现在他比我还主动发情侣照片。哈哈，这就是甜宠 App 的魔力吧。",
                    date: "2025.7.12",
                    likes: 999,
                    avater: "http://cdnwm.yuluojishu.com/uploads/20250721/e38ee98a5eba0f6010b0f8367363ea0f.jpg",
                },
            ],
            jobSelse: 1,
            input: "",
            isMobile: false,
        };
    },
    components: { MobileHome },
    mounted() {
        this.initCircleCards();
        this.initParallaxEffect();
        this.checkMobile();
        window.addEventListener("resize", this.checkMobile);
        new Swiper(".swiper-container", {
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true,
        });
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        initCircleCards() {
            const container = this.$el.querySelector(".animationBox");
            const cards = container.querySelectorAll("div");
            const total = cards.length;
            const radius = 250;

            cards.forEach((card, index) => {
                const angle = (360 / total) * index;
                card.style.transform = `
          rotate(${angle}deg)
          translate(${radius}px)
          rotate(-${angle}deg)
        `;
            });
        },
        initParallaxEffect() {
            const container = this.$el.querySelector(".animationBox");
            const cards = container.querySelectorAll("div");
            const total = cards.length;
            const radius = 250;

            container.addEventListener("mousemove", (e) => {
                const { left, top, width, height } = container.getBoundingClientRect();
                const centerX = left + width / 2;
                const centerY = top + height / 2;

                const offsetX = e.clientX - centerX;
                const offsetY = e.clientY - centerY;

                const intensity = 40;
                cards.forEach((card, index) => {
                    const speed = parseFloat(card.dataset.speed || "1");
                    const angle = (360 / total) * index;
                    const x = (offsetX / intensity) * speed;
                    const y = (offsetY / intensity) * speed;

                    card.style.transform = `
          rotate(${angle}deg)
          translate(${radius + x}px, ${y}px)
          rotate(-${angle}deg)
        `;
                });
            });

            container.addEventListener("mouseleave", () => {
                cards.forEach((card, index) => {
                    const angle = (360 / total) * index;
                    card.style.transform = `
            rotate(${angle}deg)
            translate(${radius}px)
            rotate(-${angle}deg)
          `;
                });
            });
        },
        sumbit() {
            if (this.input == "") {
                this.$message("邮箱不能为空");
                return;
            }
            this.$message({
                message: "提交成功",
                type: "success",
            });
            this.input = "";
        },
    },
};
</script>
<style src="@/style/index.css"></style>
